// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from 'react-helmet';
import { useTranslation } from "react-i18next";

// HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID, appConfig } from "../../config/appConfig";

// COMPONENTI
import SubHeaderHome from "../Header/subHeader/SubHeaderHome";
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import SubHeaderImmobili from "../Header/subHeader/SubHeaderImmobili";
import BannerVendi from "./BannerVendi";
import PropertySearchField from "./Search";
import ServicesSection from "./ServicesSection";
import Vetrina1 from "./Vetrina1";
import Vetrina2 from "./Vetrina2";
import FooterBannerVendi from "./FooterBannerVendi";
import LocationSearch from "./LocationSearch";
import Presentation from "./Presentation";
import SocialPost from "./SocialPost";
import GoogleReviews from '../Reviews/GoogleReviews';
import HomeValuation from "./HomeValuation/HomeValuation";
import TipologySearchSection from "./TipologySearchSection";

interface Props {
  seo: boolean;
  vetrina2: boolean;
  pageType: string;
  filters: { [key: string]: string[] };
  showServices: boolean;
  showLocationSearch: boolean;
  showFooterBannerVendi: boolean;
  showPresentationSection: boolean;
  showSocialSection: boolean;
  showVetrina1: boolean;
  showTipologySearch: boolean;
}

const HomePage: React.FC<Props> = ({
  seo,
  vetrina2,
  pageType,
  filters,
  showServices,
  showLocationSearch,
  showFooterBannerVendi,
  showPresentationSection,
  showSocialSection,
  showVetrina1,
  showTipologySearch
}) => {

  const { t } = useTranslation();
  const { agency } = useGetAgencyDetails(AGENCY_ID);

  // --- Lettura Flag Indipendenti dalla Configurazione ---
  const shouldShowInSubHeader = appConfig.ui.searchForm.showSearchInHomePageSubHeader;
  const shouldShowBelowIntro = appConfig.ui.searchForm.showSearchBelowHomePageIntro;
  const shouldShowSearchAndFiltersSection = appConfig.ui.homePage.showSearchAndFilters;
  const homeValuationConfig = appConfig.features.homeValuation;
  // --- Fine Lettura ---

  const isSeo = pageType === 'home';

  return (
    <>
      <Helmet>
        <title>{agency?.agencyName ?? t('common.loading')}...</title>
      </Helmet>

      {/* === Rendering Condizionale Sub Headers === */}
      {pageType === "home" && (
        <SubHeaderHome
          isSeo={isSeo}
          showSearchForm={shouldShowInSubHeader}
        />
      )}
      {pageType === "immobili" && (
        <SubHeaderImmobili
          bodyTitle={t('propertyList.pageTitle')}
          filters={filters}
        />
      )}
      {pageType === "default" && (
        <SubHeaderDefault
          title={t('homePage.subHeaderDefaultTitle')}
          isSeo={isSeo}
        />
      )}

      {shouldShowSearchAndFiltersSection && pageType === 'home' &&
        <section id="search-box"className="space-ptb position-relative">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="mb-4">
                  <h3 className="asH2SubTitle text-white">{t('homePage.searchFilterSection.title')}</h3>
                </div>
              </div>
            </div>
            {shouldShowBelowIntro && <PropertySearchField searchData={{}} />}
          </div>
        </section>
      }

      {showPresentationSection && (
        <Presentation />)
      }

      {/* Vetrina con immobili */}
      {showVetrina1 && <Vetrina1 />}

      {/* Vetrina con immobili */}
      {vetrina2 && <Vetrina2 agencyName={agency?.agencyName ?? ''} />}

      {/* Ricerca per tipologia*/}
      {showTipologySearch && <TipologySearchSection />}

      {/* Ricerca veloce con immagini */}
      {showLocationSearch && <LocationSearch seo={seo} />}

      {/* Banner con bottone */}
      <BannerVendi />

      {/* Sezione Google Reviews */}
      {appConfig.features.googleReviews.enabled && (
        <section className="space-ptb bg-gray">
          <div className="container">
            <GoogleReviews />
          </div>
        </section>
      )}

      {homeValuationConfig.enabled && homeValuationConfig.displayMode === 'banner' && (
        <section className="space-ptb bg-light">
          <div className="container">
            <HomeValuation />
          </div>
        </section>
      )}

      <ServicesSection showServices={showServices} />

      {/* Footer Banner Vendi */}
      {showFooterBannerVendi && <FooterBannerVendi />}

      {/* Social section */}
      {showSocialSection && <SocialPost />}
    </>
  );
};

export default HomePage;